import { useRef, useLayoutEffect, useEffect } from "react";
import "../App.css";
import bg from "../assets/Picsart.jpg";
// import img1 from "../assets/img1.jpg";
// import img2 from "../assets/img2.jpg";
// import img3 from "../assets/img3.jpg";
// import img4 from "../assets/img4.jpg";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import video from "../assets/Glitch.mp4";
import Services from "./Services";
import AboutUs from "./AboutUs";
import ContactUs from "./ContactUs";
import Footer from "./Footer";
import Navbar from "./Navbar";
import TextReveal from "./TextReveal";
import WebSpecification from "./WebSpecification";
gsap.registerPlugin(ScrollTrigger);

const Banner = () => {
  const bg1 = useRef(null);
  const img_container = useRef(null);
  const img = useRef(null);
  const text1 = useRef(null);
  const text2 = useRef(null);
  const container = useRef(null);
  const videoRef = useRef(null);

  useLayoutEffect(() => {
    let ctx = gsap.context(() => {
      ScrollTrigger.create({
        trigger: bg1.current,
        pin: bg1.current,
        pinSpacing: false,
        start: "top top",
        endTrigger: ".last",
        end: "bottom bottom",
      });

      // gsap.set(container.current, {
      //   marginTop: -container.current.offsetHeight,
      // });

      gsap
        .timeline({
          scrollTrigger: {
            trigger: img_container.current,
            pin: img_container.current,
            scrub: 5,
            start: "0% 0%",
          },
        })
        .to(img.current, { transform: "translateZ(2200px)" }, 0)
        .to(text1.current, { y: -800 }, 0.15, "<")
        .to(text2.current, { y: -800 }, 0.2, "<")
        .fromTo(
          container.current,
          { yPercent: 100, scaleY: 2 },
          { yPercent: 0, scaleY: 0 }
        );
    });

    
    return () => ctx.revert();
  }, []);

  

  useEffect(() => {
      // Ensure the video is muted and autoplayed
      if (videoRef.current) {
          videoRef.current.muted = true;
          videoRef.current.play();
      }
  }, []);
  
 

  return (
    <>
    <Navbar/>
      <div className="relative bg bg-[#141414]" id="home">
        <div
          ref={bg1}
          className="bg bg-[#141414] absolute h-screen w-screen z-[-1]"
        >
          <video
            className="video-background"
            loop
            muted
            autoPlay
            src={video}
          ></video>
        </div>
        <section>
          
          <div
            ref={img_container}
            className="img-container perspective flex items-center justify-center h-screen w-screen"
          >
            {/* <video
            className="video-background"
            loop
            muted
            autoPlay
            src={video}
          ></video> */}


           <video
            
            className="video-background"
            autoPlay
            loop
            muted
            playsInline
            src={video}
            
        >
            <source src="../assets/Glitch.mp4" type="video/mp4" />
            
        </video>
            <img ref={img} className="image " src={bg} alt="" />
            <div className="text-white absolute flex flex-col items-center justify-center">
              <h1 ref={text1} className="text-[70px]">
                <span className="text-5xl sm:text-9xl md:text-stroke lg:text-stroke">
                  ByteSafe
                </span>
              </h1>
              <p
                ref={text2}
                className="opacity-50 text-lg w-500 text-[13px] text-center"
              >
               Securing Tomorrow
              </p>
            </div>
          </div>
          {/* <div
            ref={container}
            className="container py-12 flex flex-wrap items-center justify-around"
          >
            <div className="col-1 flex flex-col gap-16  pb-8">
              <img src={img1} alt="" className="w-[450px] h-[350px]" />
              <img src={img2} alt="" className="w-[400px] h-[400px]" />
            </div>
            <div className="col2 flex flex-col gap-16">
              <img src={img3} alt="" className="w-[600px] h-[400px]" />
              <img src={img4} alt="" className="w-[400px] h-[400px] last`" />
            </div>
          </div> */}
        </section>
      </div>
      <TextReveal/>
      <Services/>
      <WebSpecification/>
      <AboutUs />
      {/* <ContactUs/> */}
      <Footer/> 
      
    </>
  );
};

export default Banner;
